module.exports = __webpack_public_path__ + "img/online-heading.3197db39.svg";